import React, { useState } from 'react';

import { Control } from '@vlabs/uikit';
import { Select } from '@vlabs/uikit/components/controls/select/Select';

import { loadGroupOptions } from '@vlabs/monokit/entities/sources';
import type { SourceGroupOption } from '@vlabs/monokit/entities/sources';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';
import { selectMenuPortalStyles } from '@vlabs/monokit/shared/ui/select-portal';

import { useTransferStreamsTranslation } from '../i18n';
import st from './TransferStreamsForm.module.sass';

const displayName = 'TransferStreamsForm';
const testid = buildTestid(displayName);

interface TransferStreamsFormProps {
  onCancel: VoidFunction;
  /** Форма отдаёт выбранную группу наружу — API-вызов делает вызывающий (ZEN #13). */
  onTransfer: (targetGroupId: string) => void;
  isPending?: boolean;
}

function TransferStreamsForm({
  onCancel,
  onTransfer,
  isPending = false,
}: TransferStreamsFormProps): React.JSX.Element {
  const { t } = useTransferStreamsTranslation();
  const [targetGroup, setTargetGroup] = useState<SourceGroupOption | undefined>();

  const isSubmitDisabled = !targetGroup || isPending;

  const submit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!targetGroup) return;

    onTransfer(targetGroup.value);
  };

  return (
    <form onSubmit={submit}>
      <div className={st.Root}>
        <h2 className={st.Title}>
          {t('transfer_streams_form.title')}
        </h2>

        <div className={st.Field}>
          <Select
            classNamePrefix="TransferStreamsGroup"
            defaultOptions
            isAsync
            label={t('transfer_streams_form.group')}
            loadOptions={loadGroupOptions}
            menuPortalTarget={document.body}
            onChange={(option) => setTargetGroup(option ?? undefined)}
            placeholder={t('transfer_streams_form.group')}
            styles={selectMenuPortalStyles}
            value={targetGroup}
            {...testid('targetGroup')}
          />
        </div>

        <div className={st.Actions}>
          <Control.Button
            className={st.Action}
            disabled={isSubmitDisabled}
            isLoading={isPending}
            type="submit"
          >
            {t('transfer_streams_form.on_submit')}
          </Control.Button>

          <Control.Button
            className={st.Action}
            disabled={isPending}
            kind="secondary"
            onClick={onCancel}
            type="button"
            variant="outlined"
          >
            {t('transfer_streams_form.on_cancel')}
          </Control.Button>
        </div>
      </div>
    </form>
  );
}

TransferStreamsForm.displayName = displayName;

export { TransferStreamsForm };
